import { useTranslation } from 'react-i18next';
import VideoPoster from '../../assets/535fbac30da553a0.jpg';
import Video from '../../assets/535fbac30da553a0.mp4';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H10, SubH1 } from '../../common/common-text';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const OrganizationChartSection1 = () => {
  const { t } = useTranslation();
  const { horizontal: padding, topSectionBottom: topSectionBottom } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const { isMobile } = useDeviceType();
  const viewheight = useVisualViewportHeight();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{
      background: 'black',
      ...(isMobile ? { height: viewheight } : {}),
    }}>
      <FrameLayout>
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          style={{
            width: '100%',
            height: isMobile ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        <SubH1
          style={{
            color: 'white',
            position: 'absolute',
            left: `${padding}px`,   // ✅ 좌측 여백
            bottom: isMobile ? isEng ? '158px' : '114px' : `${topSectionBottom}px`
          }}
        >
          {isMobile ? (
            <>
              Organization Chart
            </>
          ) : (
            <>
              Organization<br />
              Chart
            </>
          )}
        </SubH1>
        <H10
          style={{
            width: isMobile ? `calc(100% - ${padding * 2}px)` : pxToRem(510),
            color: 'white',
            position: 'absolute',
            bottom: isMobile ? '0px' : `${topSectionBottom}px`,
            ...(isMobile
              ? { left: `${padding}px`, minHeight: isEng ? '146px' : '102px' }
              : { right: `${padding}px` }),
          }}
        >
          {t('비비테크는 기술, 생산, 품질, 서비스 전 부문에서 체계적인 협업 구조로 운영합니다. 빠르고 정밀하게 대응하는 조직력으로 고객 가치를 실현합니다.')}
        </H10>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default OrganizationChartSection1;
